import { ArrowLeft, HeartHandshake, Lightbulb } from 'lucide-react';
import { DonationForm } from './DonationForm';

interface SupportProps {
  onBack: () => void;
}

export function Support({ onBack }: SupportProps) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 flex flex-col pb-8">
      {/* Header */}
      <div className="bg-white px-6 py-6 pt-safe-top border-b border-slate-200 sticky top-0 z-10 shadow-sm">
        <div className="flex items-center justify-between">
          <button 
            onClick={onBack}
            className="p-2 -ml-2 rounded-full hover:bg-slate-100 text-slate-600 transition-colors"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
          <div className="text-center">
            <h2 className="text-xl font-bold flex items-center justify-center gap-2">
              Support Habl.Life <HeartHandshake className="w-5 h-5 text-emerald-600" />
            </h2>
            <p className="text-sm text-slate-500">Keep the lights on & improve services</p>
          </div>
          <div className="w-10"></div>
        </div>
      </div>

      <div className="p-6 space-y-6 max-w-md mx-auto w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 text-center space-y-4">
          <div className="w-16 h-16 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-2">
            <Lightbulb className="w-8 h-8 text-emerald-600" />
          </div>
          
          <h3 className="text-xl font-bold text-slate-900">Why Support Us?</h3>
          
          <p className="text-slate-600 leading-relaxed">
            Habl.Life is dedicated to providing free, high-quality Islamic resources to everyone. Your support helps us:
          </p>
          
          <ul className="text-left text-sm text-slate-600 space-y-3 bg-slate-50 p-4 rounded-xl">
            <li className="flex gap-2">
              <span className="text-emerald-600 font-bold">✓</span> Cover server & database costs
            </li>
            <li className="flex gap-2">
              <span className="text-emerald-600 font-bold">✓</span> Develop new features (Kids Mode, Audio)
            </li>
            <li className="flex gap-2">
              <span className="text-emerald-600 font-bold">✓</span> Keep the app ad-free forever
            </li>
          </ul>

          <div className="bg-amber-50 p-4 rounded-xl border border-amber-100 text-left mb-6">
            <p className="text-xs text-amber-800 font-medium flex gap-2">
              <span className="text-xl">💡</span>
              <span>
                <strong>Did you know?</strong> Supporting beneficial knowledge is a form of <em>Sadaqah Jariyah</em> (Ongoing Charity).
              </span>
            </p>
          </div>

          <DonationForm />
          
          <p className="text-xs text-slate-400 mt-4">
            Secure payment processing.
          </p>
        </div>
      </div>
    </div>
  );
}
